import React from "react";
import { ArrowPathIcon } from "@heroicons/react/24/solid";

const EditFeedbackForm = ({
  editForm,
  onChange,
  onFileChange,
  onSubmit,
  onCancel,
  isLoading,
}) => {
  const rateOptions = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];

  return (
    <form
      onSubmit={onSubmit}
      className="grid grid-cols-2 gap-4 p-6 bg-white rounded-lg shadow-lg w-[90%] max-w-2xl"
    >
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black">Name (EN)</label>
        <input
          type="text"
          name="name_en"
          value={editForm.name_en}
          onChange={onChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black">Name (AR)</label>
        <input
          type="text"
          name="name_ar"
          value={editForm.name_ar}
          onChange={onChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black">
          Description (EN)
        </label>
        <textarea
          type="text"
          name="desc_en"
          value={editForm.desc_en}
          onChange={onChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black">
          Description (AR)
        </label>
        <textarea
          type="text"
          name="desc_ar"
          value={editForm.desc_ar}
          onChange={onChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      <div className="flex flex-col col-span-2">
        <label className="text-sm font-semibold text-black">Rate</label>
        <select
          name="rate"
          value={editForm.rate || ""}
          onChange={onChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        >
          <option value="" className="text-black">
            Select Rate
          </option>
          {rateOptions.map((option) => (
            <option key={option} value={option} className="text-black">
              {option} ⭐
            </option>
          ))}
        </select>
      </div>

      <div className="flex justify-end col-span-2 mt-2 space-x-3">
        {isLoading ? null : (
          <button
            className="px-4 py-2 text-white duration-300 bg-gray-600 rounded-lg hover:bg-gray-800"
            onClick={onCancel}
          >
            Cancel
          </button>
        )}
        {isLoading ? (
          <ArrowPathIcon className="w-10 h-10 p-2 text-white rounded-full animate-spin bg-custom-yellow" />
        ) : (
          <button
            type="submit"
            className="px-4 py-2 text-white duration-300 rounded-lg bg-custom-yellow hover:bg-yellow-600"
          >
            Submit
          </button>
        )}
      </div>
    </form>
  );
};

export default EditFeedbackForm;
